export default __webpack_public_path__ + "static/media/tituloEN.b807cc15.png";